import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { StatusBadge } from "./common";
import { TURF_TALK, inquiryMailto } from "../data/content";

const CardImage = () => (
    <div className="relative overflow-hidden border-b border-thg-border">
        <img
            src="/assets/products/turf-talk-phones.jpg"
            alt="Turf Talk mobile app — three phone screens: today's slate, every game state, and the matchup view"
            className="w-full aspect-[16/9] object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
            loading="lazy"
        />
        <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_70px_rgba(0,0,0,0.5)]" aria-hidden="true" />
    </div>
);

const BadgeRow = () => (
    <div className="flex flex-wrap items-center gap-3">
        <StatusBadge testId="product-status-turf-talk">Closed Beta · Controlled Demonstrations</StatusBadge>
        <span className="text-xs tracking-[0.15em] uppercase text-thg-tertiary">SportChant, LTD.</span>
    </div>
);

const Ownership = () => (
    <p className="mt-3 text-xs leading-relaxed text-thg-tertiary">
        Owned and operated by SportChant, LTD., a New York corporation — the rebuilt experience was designed and
        built with Titan Haven Group LLC.
    </p>
);

const SUMMARY =
    "A football second-screen experience — game-day conversation, picks and predictions, rivalry leagues, and original character programming in one product.";

// Single approved Turf Talk treatment. variant="card" = grid card (portfolio);
// variant="spotlight" = full-width demonstrable-product spotlight (homepage lead,
// after the commercial tier). Shared so surfaces cannot drift. SportChant, LTD.
// owns and operates; THG designed and built — never implied as THG-owned.
export const TurfTalkCard = ({ spotlight = false }) => {
    if (spotlight)
        return (
            <div
                className="group bg-thg-surface border border-thg-border grid md:grid-cols-2"
                data-testid="turftalk-spotlight"
            >
                <Link to="/portfolio/turf-talk-2" data-testid="turftalk-spotlight-image-link" className="block">
                    <CardImage />
                </Link>
                <div className="p-8 md:p-10 flex flex-col justify-center">
                    <BadgeRow />
                    <h3 className="mt-5 font-display font-medium text-white text-2xl md:text-3xl">{TURF_TALK.name}</h3>
                    <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">{SUMMARY}</p>
                    <Ownership />
                    <div className="mt-6 flex flex-wrap items-center gap-4">
                        <a
                            href={inquiryMailto("Turf Talk Demo Request")}
                            data-testid="turftalk-spotlight-demo-cta"
                            className="inline-flex items-center gap-2 bg-thg-red text-white hover:bg-thg-redhover transition-colors duration-300 px-5 py-2.5 text-sm tracking-wide uppercase"
                        >
                            Request a Demonstration <ArrowUpRight size={15} />
                        </a>
                        <Link
                            to="/portfolio/turf-talk-2"
                            data-testid="turftalk-spotlight-view"
                            className="inline-flex items-center gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300"
                        >
                            View product
                            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                        </Link>
                    </div>
                </div>
            </div>
        );
    return (
        <Link
            to="/portfolio/turf-talk-2"
            data-testid="product-card-turf-talk"
            className="group block bg-thg-surface border border-thg-border hover:bg-thg-surfacehover hover:border-[#404040] transition-colors duration-300"
        >
            <CardImage />
            <div className="p-8 md:p-10">
                <BadgeRow />
                <h3 className="mt-5 font-display font-medium text-white text-2xl md:text-3xl">{TURF_TALK.name}</h3>
                <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">{SUMMARY}</p>
                <Ownership />
                <span className="mt-6 inline-flex items-center gap-2 text-sm text-thg-secondary group-hover:text-white transition-colors duration-300">
                    View product
                    <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
            </div>
        </Link>
    );
};
